<div class="loader-overlay-container" *ngIf="show">
            <div class="spinner-wrapper">
                <span class="spinner-border text-primary spinner-wdth spinner-animation"></span>
            </div>
</div>